import { adminAPI } from '../../config';
import Request from '../../utils/Request';

export const authApi = {
    me: () => Request.get(adminAPI.adminUser.me),
    signIn: (values) => Request.post(adminAPI.auth.signIn, values),
    logout: () => Request.post(adminAPI.auth.logout, {}),
    googleRedirectUrl: () => Request.get(adminAPI.auth.google.redirectUrl),
    googleCallback: (code) => Request.post(adminAPI.auth.google.callback, { code }),
    mfaSetup: () => Request.get(adminAPI.adminUser.mfa.setup),
    mfaVerify: (payload) => Request.post(adminAPI.adminUser.mfa.verify, payload),
    ipWhitelist: (ip) => Request.post(adminAPI.adminUser.mfa.ipWhitelist, { ip })
};
